import Command from './command.class';
import { translateCommand, translateSettings, V1Publish, V1PublishKind } from '../services/mqtt/v1/v1Commands';

type Snapshot = { live: Record<string, any>; settings: Record<string, any> };

/**
 * The `Command` the control pages already hold, for a V1 / Coldfire spa.
 *
 * Same two entry points (`executeSingle`, `updateSettings`), so the pages don't know
 * which generation of spa they are driving. Each call is translated from the V2
 * vocabulary into V1 envelopes (see `v1Commands.ts`) and published on the spa's
 * legacy-broker socket. Toggles need the spa's current state to decide what "next" is,
 * so the hook hands in a reader for its latest live/settings snapshot.
 */
class V1Command extends Command {
  private readonly publishFn: (kind: V1PublishKind, body: Record<string, any>) => boolean;
  private readonly snapshot: () => Snapshot;

  constructor(publishFn: (kind: V1PublishKind, body: Record<string, any>) => boolean, snapshot: () => Snapshot) {
    super('');
    this.publishFn = publishFn;
    this.snapshot = snapshot;
  }

  private send(publishes: V1Publish[]): void {
    publishes.forEach((p) => this.publishFn(p.kind, p.body));
  }

  executeSingle(commandKey: string, value: any = null): void {
    this.send(translateCommand(commandKey, value, this.snapshot().live));
  }

  updateSettings(params: Object): void {
    this.send(translateSettings(params as Record<string, any>, this.snapshot().settings));
  }
}

export default V1Command;
